import React, { useState } from "react";
import { IoMdClose } from "react-icons/io";
import { useDispatch } from "react-redux";

import { setAppError } from "../../../../store/userSlice";
import nodeinstance from "../../../../nodeInstance";
import { useNavigate } from "react-router-dom";

function FinPayRollPopUP({ PopUp, setPopUp, list, url, callBack, token }) {
  const dispatch = useDispatch();

  const [edit, setEdit] = useState(false);

  const handleEditClick = () => {
    setEdit(true);
  };
  const [newPopUp, setNewPopUp] = useState(false);
  const handleClick = () => {
    setNewPopUp(true);
  };
  const handleClickCancel = () => {
    setNewPopUp(false);
  };
  const [formData, setFormData] = useState({
    bankName: "",
    accountNNumber: "",
    IBANNumber: "",
    atmNumber: "15121",
    cardExpiry: "",
  });
  const navigate = useNavigate();
  const [personal, setPersonal] = useState(false);

  function handlepersonal(e) {
    e.preventDefault();
    setPersonal(true);
    // console.log("target value to be printed here", e);
  }
  const update = async () => {
    var type = {
      employee_id: list.employee_id,
      bank_name: formData.bankName === "" ? null : formData.bankName,
      account_number:
        formData.accountNNumber === "" ? null : formData.accountNNumber,
      iban_number: formData.IBANNumber === "" ? null : formData.IBANNumber,
      atm_card_number: formData.atmNumber === "" ? null : formData.atmNumber,
      atm_card_expiry: formData.cardExpiry === "" ? null : formData.cardExpiry,
      payrollCategory:
        list.account_opened_by === "PAYROLL" ? "PERSONAL" : "PAYROLL",
    };
    console.log(type);
    console.log(url);
    try {
      const res = await nodeinstance.post(url, type, {
        headers: { Authorization: `Bearer ${token}` },
      });
      console.log(res);
      if (res.status == 200) {
        dispatch(
          setAppError({
            msg: res?.data?.message,
            color: "success",
          })
        );
      }
      navigate(`/dashboard/fin-atm-payroll/`);
    } catch (error) {
      dispatch(
        setAppError({
          msg: error?.response?.data.error,
        })
      );
    }
  };

  const handleKeyDown = (event) => {
    event.preventDefault(); // Prevent typing in the input field
  };

  console.log("I am seeing popUp page in console", list);

  const [oldData, setOldData] = useState({
    employee_id: list.employee_id,
    bank_name: list.bank_name,
    account_number: list.account_number,
    iban_number: list.iban_number,
    atm_card_number: list.atm_card_number,
    atm_card_expiry: list.atm_card_expiry,
  });
  const handleDateChange = (e) => {
    const { id, value } = e.target;
    setOldData((prevData) => ({
      ...prevData,
      [id]: value, // Update the date value in state
    }));
  };

  const editClick = async () => {
    try {
      const response = await nodeinstance.put(
        `/atm-payroll/updateData`,
        oldData,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.status === 200) {
        dispatch(setAppError({ msg: response.data.message, color: "sucess" }));
        callBack();
        setPopUp(false);
      }
    } catch (error) {
      console.log("error to be seen in the console", error);
    }
  };
  return (
    <>
      <div
        className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50  justify-center items-center ${
          PopUp ? "flex" : "hidden"
        }`}
      >
        <div className="w-max h-auto   rounded-md bg-white/95 flex  flex-col p-4 relative">
          <div className="flex justify-between items-center w-full">
            <h1
              className="text-md font-semibold cursor-pointer"
              onClick={() => {
                setPopUp(false);
              }}
            >
              <IoMdClose />
            </h1>
          </div>
          {newPopUp ? (
            <div className="w-full flex flex-col items-center space-y-4">
              {list.account_opened_by === "PAYROLL" ? (
                <h1>
                  {`This will lead to cancel the payroll and change to personal`}
                </h1>
              ) : (
                <h1>{`Category change from personal to payroll`}</h1>
              )}
              <div className="w-full flex justify-center">
                <button
                  className="p-2 rounded-md bg-green-400 text-white text-xs"
                  onClick={() => update()}
                >
                  <p>Submit</p>
                </button>
                <button
                  className="p-2 rounded-md bg-red text-white text-xs ml-4"
                  onClick={() => handleClickCancel()}
                >
                  <p>Cancel</p>
                </button>
              </div>
            </div>
          ) : (
            <div className="w-full">
              <div className="w-full flex flex-col"></div>
              <h1 className="text-gray text-xl font-semibold text-center">
                CHANGE {list.account_opened_by} CATEGORY
              </h1>
              <div className="flex gap-x-14 mt-4">
                <div>
                  <p className="text-sm">EMPLOYEE NAME</p>
                  <p className="text-md font-semibold">{list.name}</p>
                </div>
                <div>
                  <p className="text-sm">EMPLOYEE ID</p>
                  <p className="text-md font-semibold">{list.employee_id}</p>
                </div>
                <div>
                  <p className="text-sm">CLIENT</p>
                  <p className="text-md font-semibold">{list.client}</p>
                </div>
                <div>
                  <p className="text-sm">VISA PROVIDER</p>
                  <p className="text-md font-semibold">{list.visa_provider}</p>
                </div>
                <div>
                  <p className="text-sm">IQAMA NUMBER</p>
                  <p className="text-md font-semibold">{list.iqama_number}</p>
                </div>
                <div>
                  <p className="text-sm">IQAMA EXPIRY</p>
                  <p className="text-md font-semibold">
                    {list.iqama_expiry_date_g}
                  </p>
                </div>
                <div>
                  <p className="text-sm">KSA CONTACT #</p>
                  <p className="text-md font-semibold">
                    {list.mobile_number || "-"}
                  </p>
                </div>
              </div>

              <div className="flex w-[80%] mx-auto gap-x-4 mt-4 ">
                <div className="w-[48%] pb-10 bg-[#F3F3F3]  text-gray  ">
                  {personal == false ? (
                    <div className="flex w-[100%]  bg-green-500 text-white justify-end ">
                      <p className="mr-36">{list.account_opened_by}</p>
                      <p className=" mr-2">ACTIVE</p>
                    </div>
                  ) : (
                    <div className="text-center">
                      <p className="w-[100%] bg-gray text-white ">
                        {list.account_opened_by}
                      </p>
                    </div>
                  )}
                  <div className="text-center mt-2">
                    <button
                      onClick={() => {
                        handleEditClick();
                      }}
                      disabled={personal}
                    >
                      Edit
                    </button>
                  </div>

                  <div className=" flex flex-col mt-6  ml-8 w-[90%] gap-y-4 ">
                    <div className="flex  justify-between">
                      <p>BANK NAME</p>
                      {/* <p>{list.bank_name}</p> */}
                      <input
                        type="text"
                        id="bank_name"
                        value={oldData.bank_name}
                        disabled
                        onChange={handleDateChange}
                      />
                    </div>
                    <div className="flex  justify-between">
                      <p className="text-md">ACCOUNT NUMBER</p>
                      {/* <p>{list.account_number}</p> */}
                      <input
                        type="text"
                        id="account_number"
                        value={oldData.account_number}
                        disabled
                        onChange={handleDateChange}
                      />
                    </div>
                    <div className="flex justify-between">
                      <p>IBAN NUMBER</p>
                      {/* <p>{list.iban_number} </p> */}
                      <input
                        type="text"
                        id="iban_number"
                        value={oldData.iban_number}
                        disabled
                        onChange={handleDateChange}
                      />
                    </div>
                    <div className="flex justify-between">
                      <p>ATM CARD NUMBER</p>
                      {/* <p>{list.atm_card_number}</p> */}
                      <input
                        type="text"
                        id="atm_card_number"
                        value={oldData.atm_card_number}
                        disabled
                        onChange={handleDateChange}
                      />
                    </div>
                    <div className="flex  justify-between">
                      <p>ATM CARD EXPIRY</p>
                      {/* <p>{list.atm_card_expiry}</p> */}
                      <input
                        type="date"
                        id="atm_card_expiry"
                        value={
                          oldData.atm_card_expiry
                            ? new Date(oldData.atm_card_expiry)
                                .toISOString()
                                .split("T")[0]
                            : "" // Ensure the value is in YYYY-MM-DD format
                        }
                        onChange={handleDateChange}
                        disabled
                      />
                    </div>
                    <div className="text-center mt-2">
                      <button
                        onClick={() => {
                          editClick();
                        }}
                        disabled={!edit}
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </div>

                {/* second */}
                <div className="bg-[#F3F3F3] w-[48%] text-center flex flex-col pb-4">
                  {personal == false ? (
                    <p className="w-[100%] bg-gray text-white ">
                      {list.account_opened_by === "PAYROLL"
                        ? "PERSONAL"
                        : "PAYROLL"}
                      {/* {list.account_opened_by != "PAYROLL"
                      ? "PERSONAL"
                      : list.account_opened_by != "PERSONAL"
                        ? "PAYROLL"
                        : "PAYROLL"} */}
                    </p>
                  ) : (
                    <div className="flex w-[100%]  bg-green-500 text-white justify-end ">
                      <p className="mr-36">
                        {/* {list.account_opened_by} */}
                        {list.account_opened_by === "PAYROLL"
                          ? "PERSONAL"
                          : "PAYROLL"}
                      </p>
                      <p className=" mr-2">ACTIVE</p>
                    </div>
                  )}

                  <div className="h-[100%] w-[100%] flex justify-center items-center ">
                    {personal == false ? (
                      <button
                        className="text-sm bg-green-500 px-4 py-2 text-white"
                        // onClick={() => {
                        //   handlepersonal(
                        //     list.account_opened_by === "PAYROLL"
                        //       ? "PERSONAL"
                        //       : "PAYROLL"
                        //   );
                        // }}
                        onClick={handlepersonal}
                        disabled={edit}
                      >
                        SWITCH TO{" "}
                        {list.account_opened_by === "PAYROLL"
                          ? "PERSONAL"
                          : list.account_opened_by === "PERSONAL"
                            ? "PAYROLL"
                            : "PAYROLL"}
                      </button>
                    ) : (
                      <div className=" flex flex-col mt-6  ml-8 w-[90%] gap-y-4  text-gray pr-2">
                        <div className="flex  justify-between">
                          <p>BANK NAME</p>
                          <input
                            type="text"
                            name="bankName"
                            onChange={(event) =>
                              setFormData({
                                ...formData,
                                bankName: event.target.value,
                              })
                            }
                            placeholder="bank Name"
                            className="input input-sm input-bordered"
                            disabled
                          />
                        </div>
                        <div className="flex  justify-between">
                          <p className="text-md">ACCOUNT NUMBER</p>
                          <input
                            type="number"
                            name="accountNNumber"
                            onChange={(event) =>
                              setFormData({
                                ...formData,
                                accountNNumber: event.target.value,
                              })
                            }
                            placeholder="608010167519"
                            className="input input-sm input-bordered"
                            disabled
                          />
                        </div>
                        <div className="flex justify-between">
                          <p>IBAN NUMBER</p>
                          <input
                            type="text"
                            name="IBANNumber"
                            onChange={(event) =>
                              setFormData({
                                ...formData,
                                IBANNumber: event.target.value,
                              })
                            }
                            placeholder="SA038000608010167519"
                            className="input input-sm input-bordered"
                            disabled
                          />
                        </div>
                        <div className="flex justify-between">
                          <p>ATM CARD NUMBER</p>
                          <input
                            type="number"
                            name="atmNumber"
                            onChange={(event) => {
                              setFormData({
                                ...formData,
                                atmNumber: event.target.value,
                              });
                              console.log(event.target.value);
                            }}
                            placeholder="1234567898745632"
                            className="input input-sm input-bordered"
                            disabled
                          />
                        </div>
                        <div className="flex  justify-between">
                          <p>ATM CARD EXPIRY</p>
                          <input
                            className="input input-sm input-bordered"
                            type="date"
                            onKeyDown={handleKeyDown}
                            name="cardExpiry"
                            onChange={(event) =>
                              setFormData({
                                ...formData,
                                cardExpiry: event.target.value,
                              })
                            }
                            placeholder="DD-MM-YYYY"
                            disabled
                          />
                        </div>

                        <div className="text-white text-end w-fit ml-[14.5rem]">
                          <button
                            className="p-2 rounded-md bg-green-400 text-white text-xs flex text-center"
                            onClick={() => handleClick()}
                          >
                            <p>UPDATE BANK DETAILS</p>
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default FinPayRollPopUP;
